import { z } from 'zod';
import { eventType, EventBaseSchema } from '@eigtech/event-stream-types';
export const assignmentsServiceName = 'assignments';
export const serviceEventType = (entity, eventName) => eventType(assignmentsServiceName, entity, eventName);
export const AssignmentsServiceEventBaseSchema = EventBaseSchema.extend(z.object({
    type: serviceEventType(),
}).shape);
export const AssignmentsServiceRequestActorEnumSchema = z.enum(['CONTACT_MERGED']);
export const AssignmentsServiceRequestActor = AssignmentsServiceRequestActorEnumSchema.enum;
